import React, { ReactNode, FC, MouseEventHandler } from "react";
import AuthenticatedAvatar from "./AuthenticatedAvatar";
import "../avatarWithRemove/AvatarWithRemove.scss";

type Props = {
  onClick: MouseEventHandler<HTMLSpanElement>;
  size: number | "large" | "small" | "default";
  showRemove: boolean;
  avatarUrl: string | null | undefined;
  fallback: string;
  icon?: ReactNode;
  fontSize?: number;
  tooltip?: string;
};

/**
 * Avatar with remove button that fetches from authenticated endpoints.
 */
const AuthenticatedAvatarWithRemove: FC<Props> = ({
  size,
  icon,
  avatarUrl,
  fallback,
  fontSize,
  tooltip,
  onClick,
  showRemove,
}) => {
  return (
    <div className="avatar__container">
      {showRemove ? (
        <span className="avatar__remove-icon" onClick={onClick}>
          <i className="bi bi-x" />
        </span>
      ) : null}
      <AuthenticatedAvatar
        size={size}
        icon={icon}
        avatarUrl={avatarUrl}
        fallback={fallback}
        fontSize={fontSize}
        tooltipTitle={tooltip}
        placement="bottom"
      />
    </div>
  );
};

export default AuthenticatedAvatarWithRemove;
